<template>
  <div>


  <fragment>
    <label>Verification Mode:</label>
    <app-input class="col-sm-8"
               type="select"
               :list="verificationList"
               v-model="selectedVerification"
               :disabled="isSelectedDisabled"
               :required="true"
               v-on:change="verificationOnChange"
    />

    <br>
    <label for="Date">Select Date</label>
    <app-input
        class="col-sm-8"
        type="date"
        v-model="selectedDate"
        today
    />

    <label>Select Action:</label>
    <app-input class="col-sm-8"
               type="select"
               :list="dynamicSteps"
               v-model="selectedStep"
               :required="true"/>

    <template v-if="selectedVerification === 'written'">
      <label>Email Delivery Method:</label>
      <app-input class="col-sm-8"
                 type="select"
                 :list="emailDeliveryOptions"
                 v-model="emailDeliveryMethod"
      />
    </template>


    <label>Action Comment:</label>
    <div v-if="showWrittenHelpText" class="help-text">
      <div class="help-content">
        <strong>📢 Important Information:</strong>
        <p>Below is the template, Please tailor it according to your requirement. </p>
        <p>
          The email will be sent based on the selected action. If needed, the URL can be shared separately through the
          comments section.
        </p>
        <p>Please ensure that the recipient has access to the provided link if shared separately.</p>
      </div>
      <button class="close-btn" @click="showWrittenHelpText = false">✖</button>
    </div>

    <app-input class="col-sm-8"
               :id="editorId"
               type="text-editor"
               v-model="commentText"
               placeholder="Write Comment"
               :required="true"/>
    <multi-upload-btn
        ref="multiUpload"
        :uploadedFile="this.uploadedFile"
        :emailAddress="this.emailAddress"
    />

    <el-button class="secondary ml-3 mt-2"
               @click="saveComment()">
      {{ saveActionLabel }}
    </el-button>

  </fragment>
  <fragment>
    <div v-if="generatedLink" class="alert alert-info mt-3">
      <p>🔗 <strong>Generated Email Link:</strong></p>
      <p><a :href="generatedLink" target="_blank">{{ generatedLink }}</a></p>
      <el-button size="mini" @click="copyLink(generatedLink)">Copy Link</el-button>
    </div>
  </fragment>

  </div>
</template>

<script>
import {
  dateFormatter,
  pushStepIntoSpecificIndex
} from "@Views/Screening/utility/common";
import {
  _status,
  verificationList,
  oralSteps,
  writtenSteps
} from '@Views/Screening/utility/constant';
import {updateCommentSteps} from "@Views/Screening/utility/common/comment";
import {Comment} from "@Views/Screening/utility/apiAgent";

export default {
  name: "CustomizedComments",
  props: {
    applicantId: Number,
    statusable_type: String,
    statusable_id: Number,
    emailAddress: String,
    comment: Array,
    steps: Array,
    history: Object,
    applicant: {
      type: Object,
      default: () => ({})
    },
    company: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      comments: [],
      status: '',
      emailText: '',
      selectedVerification: '',
      uploadedFile: [],
      dynamicSteps: [],
      commentText: '',
      selectedStep: '',
      selectedDate: '',
      isSelectedDisabled: false,
      showCommentList: false,
      commentList: [],
      verificationList: verificationList,
      statusList: _status,
      oralSteps: oralSteps,
      writtenSteps: writtenSteps,
      showWrittenHelpText: false,
      emailDeliveryMethod: 'auto',
      generatedLink: null,
      editorId: `history-comment-editor-${this._uid}`,
      parentModalElement: null,
      onParentModalHidden: null,
      drawerWrapperElement: null,
      drawerObserver: null
    }
  },
  watch: {
    statusable_type: 'checkStatusableType'
  },
  computed: {
    historyType() {
      return this.statusable_type
    },
    saveActionLabel() {
      return this.comment.status === 'Email to employer'
          ? 'Send Email and Save Action'
          : 'Save Action';
    },
    hideAutoEmail() {
      // Auto email is only supported for Employment and Education types.
      // Unemployment and Self-Employment do not have an auto-email handler,
      // so restrict them to manual (link) only.
      return [
        'App\\Models\\Screening\\ApplicantUnemployment',
      ].includes(this.historyType);
    },
    emailDeliveryOptions() {
      const options = [
        { id: 'manual', value: 'Generate Link to Share Manually' },
      ];
      if (!this.hideAutoEmail) {
        options.push({ id: 'auto', value: 'Send Email Automatically' });
      }
      return options;
    },
  },
  mounted() {
    this.checkStatusableType();
    this.registerModalCloseHandler();
    this.registerDrawerCloseHandler();
  },
  beforeDestroy() {
    this.unregisterModalCloseHandler();
    this.unregisterDrawerCloseHandler();
  },
  methods: {
    dateFormatter,
    pushStepIntoSpecificIndex,
    updateCommentSteps,

    checkStatusableType() {
      if ([
        'App\\Models\\Screening\\ApplicantUnemployment',
        'App\\Models\\Screening\\ApplicantEducation'
      ].includes(this.historyType)) {
        this.selectedVerification = 'general';
        this.verificationOnChange();
      } else {
        this.selectedVerification = '';
      }
      // Default to manual when Send Email Automatically is hidden
      if (this.hideAutoEmail) {
        this.emailDeliveryMethod = 'manual';
      }
    },

    async saveComment() {
      if (this.commentText !== '') {
        await this.$refs.multiUpload.submitUpload();
        const commentObj = {
          statusable_type: this.historyType,
          statusable_id: this.statusable_id,
          status: this.selectedStep,
          status_type: this.selectedVerification,
          action_comment: this.commentText,
          created_at: this.selectedDate,
          applicant_files: this.uploadedFile.map(x => x.id),
          email_method: this.emailDeliveryMethod
        };

        Comment.saveComment(this.applicantId, commentObj)
            .then(({data}) => {
              const savedStatus = data?.screeningStatus || {};
              const savedComment = {
                id: savedStatus.id,
                statusable_id: savedStatus.statusable_id || commentObj.statusable_id,
                statusable_type: savedStatus.statusable_type || commentObj.statusable_type,
                status: savedStatus.status || commentObj.status,
                status_type: savedStatus.status_type || commentObj.status_type,
                action_comment: savedStatus.action_comment || commentObj.action_comment,
                created_at: savedStatus.created_at || commentObj.created_at,
                include_in_report: !!savedStatus.include_in_report,
                applicant_files: Array.isArray(savedStatus.applicant_files) ? savedStatus.applicant_files : [],
                screening_endorsement: savedStatus.screening_endorsement || savedStatus.screeing_endorsement || null
              };

              this.comments.push(savedComment);
              this.updateCommentSteps(savedComment, false);
              if(this.emailDeliveryMethod !== 'manual'){
                this.resetForm();
              }
              this.$emit('status-updated', savedComment);

              if (this.emailDeliveryMethod === 'manual') {
                this.generatedLink = savedStatus.link;
                this.resetForm();
              } else {
                this.$toastr.s("Email has been sent successfully.");
              }
            });
      }
    },

    resetForm() {
      this.selectedStep = '';
      // this.history.screening_endorsement = '';
      this.selectedVerification = '';
      this.selectedDate = '';
      this.uploadedFile.splice(0);
      this.dynamicSteps = [];
      this.isSelectedDisabled = false;
      this.showWrittenHelpText = false;
      this.emailDeliveryMethod = this.hideAutoEmail ? 'manual' : 'auto';
      this.$hub.$emit('clear-uploaded-files');
      this.commentText = '';

    },

    registerModalCloseHandler() {
      this.parentModalElement = this.$el.closest('.modal');
      if (!this.parentModalElement) return;
      this.onParentModalHidden = () => {
        this.generatedLink = null;
        this.resetForm();
      };
      $(this.parentModalElement).on('hidden.bs.modal', this.onParentModalHidden);
    },

    unregisterModalCloseHandler() {
      if (!this.parentModalElement || !this.onParentModalHidden) return;
      $(this.parentModalElement).off('hidden.bs.modal', this.onParentModalHidden);
    },

    registerDrawerCloseHandler() {
      this.drawerWrapperElement = this.$el.closest('.el-drawer__wrapper');
      if (!this.drawerWrapperElement || typeof MutationObserver === 'undefined') return;

      this.drawerObserver = new MutationObserver(() => {
        if (this.drawerWrapperElement.style.display === 'none') {
          this.generatedLink = null;
          this.resetForm();
        }
      });

      this.drawerObserver.observe(this.drawerWrapperElement, {
        attributes: true,
        attributeFilter: ['style', 'class']
      });
    },

    unregisterDrawerCloseHandler() {
      if (this.drawerObserver) {
        this.drawerObserver.disconnect();
        this.drawerObserver = null;
      }
      this.drawerWrapperElement = null;
    },

    verificationOnChange() {
      this.dynamicSteps = [];
      this.isSelectedDisabled = false;
      this.dynamicSteps.push({id: 'select', value: 'Select Step'});
      if (this.selectedVerification === 'oral') {
        this.dynamicSteps.push(...this.oralSteps);
        this.commentText = this.setFormattedText();
      } else if (this.selectedVerification === 'general') {
        this.dynamicSteps.push(...this.statusList);
      } else {
        this.showWrittenHelpText = true;
        this.commentText = this.setFormattedText();
        this.dynamicSteps.push(...this.writtenSteps);
      }
    },

    setFormattedText() {
      if (this.statusable_type === "App\\Models\\Screening\\ApplicantEmployment") {
        return `
          <h5 style="text-align: center; text-decoration: underline;">AGENCY EMPLOYMENT REFERENCE</h5>
          
          <h6>APPLICANT INFORMATION</h6>
          <p>
            Applicant Name: <u>${this.applicant.forename || ''} ${this.applicant.surname || ''}</u><br>
            Applicant Date of Birth: <u>${this.applicant.date_of_birth || 'N/A'}</u><br>
            Applicant NI Number: <u>${this.applicant.n_i_number || 'N/A'}</u>
          </p>

          <h6>INFORMATION PROVIDED BY THE APPLICANT</h6>
          <p>
            Date from: <u>${this.history.start_date_formatted || "N/A"}</u> &nbsp;&nbsp;
            Date to: <u>${this.history.end_date_formatted || "N/A"}</u>
          </p>

          <h6>PLEASE CONFIRM BELOW INFORMATION</h6>
          <p>
            Employment/placement start date: <u>${this.history.start_date_formatted || "____________________"}</u><br>
            Employment/placement end date: <u>${this.history.end_date_formatted || "____________________"}</u><br>
            Job title: <u>${this.history.title || "N/A"}</u><br>
            Client/location services were delivered: <u>${this.history.company_name || "N/A"}</u><br>
            Reason for leaving: <u>${this.history.reason_for_leaving || "Not provided"}</u>
          </p>

          <h6>YOUR DETAILS</h6>
          <p>
            Full name: <u>${this.history.contact_name || "____________________"}</u><br>
            Contact number: <u>${this.history.contact_number || "____________________"}</u><br>
            Email address: <u>${this.history.contact_email || "____________________"}</u><br>
            Employment Agency Name: <u>${this.company?.company_name || 'Onchip'}</u>
          </p>
        `;
      } else if (this.statusable_type === "App\\Models\\Screening\\ApplicantEducation") {
        return `
      <p><b>Dates Attended (as stated by institution)</b><br>
      From: <u>${this.history.start_date_formatted || "N/A"}</u> &nbsp;&nbsp;
      To: <u>${this.history.end_date_formatted || "N/A"}</u></p>

      <p><b>Dates Attended (as stated by applicant)</b><br>
      From: <u>${this.history.applicant_start_date || "N/A"}</u> &nbsp;&nbsp;
      To: <u>${this.history.applicant_end_date || "N/A"}</u></p>

      <p><b>Qualification Achieved:</b><br>
      ${this.history.qualification || "Not provided"}</p>

      <p><b>Course Length:</b><br>
      ${this.history.course_length || "Not provided"}</p>

      <p><b>Award Date:</b><br>
      ${this.history.award_date_formatted || "N/A"}</p>

      <p><b>Was the student:</b><br>
      Punctual: <u>${this.history.punctual ? "Yes" : "Not Applicable"}</u> &nbsp;&nbsp;
      Good Conduct: <u>${this.history.good_conduct ? "Yes" : "Not Applicable"}</u></p>

      <p><b>Would you accept the student again?</b><br>
      ${this.history.accept_again ? "Yes" : "Not Applicable"}<br>
      If not, why not?<br>
      ${this.history.accept_again_reason || "Not provided"}</p>

      <p><b>Institution Address:</b><br>
      ${this.history.institute_address || "Not provided"}</p>

      <p><b>Tel No.:</b> ${this.history.contact_number || "N/A"} &nbsp;&nbsp;
      <b>Email:</b> ${this.history.contact_email || "N/A"}</p>

      <p><b>Comments:</b><br>
      ...</p>
    `;
      } else if (this.statusable_type === "App\\Models\\Screening\\ApplicantUnemployment") {
        const title = this.history.company_name === "Other" ? "Other" : "Unemployment";
        return `
          <h5 style="text-align: center; text-decoration: underline;"> ${title}</h5>

          <h6>INFORMATION PROVIDED BY THE APPLICANT</h6>
          <p>
            ${title} start date: <u>${this.history.start_date_formatted || "____________________"}</u><br>
            ${title} end date: <u>${this.history.end_date_formatted || "____________________"}</u><br>
            More Info: <u>${this.history.more_information || "Not provided"}</u>
          </p>
        `;
      }else if (this.statusable_type === "App\\Models\\Screening\\ApplicantSelfEmployment") {
          return `<p><b>Trading Name / Business Name:</b><br>
                      ${this.history.name || "Not provided"}</p>

                      <p><b>UTR / Company Number:</b><br>
                      ${this.history.utr_number || "Not provided"}</p>

                      <p><b>Trading / Business Details:</b><br>
                      ${this.history.details || "Not provided"}</p>

                      <p><b>Trading / Business Address:</b><br>
                      ${this.history.address || "Not provided"}</p>

                      <p><b>Accountant Name:</b><br>
                      ${this.history.accountant_name || "Not provided"}</p>

                      <p><b>Accounting Firm:</b><br>
                      ${this.history.accounting_firm || "Not provided"}</p>

                      <p><b>Contact Number:</b><br>
                      ${this.history.contact_number || "N/A"}</p>

                      <p><b>Contact Email:</b><br>
                      ${this.history.contact_email || "N/A"}</p>

                      <p><b>Business Period:</b><br>
                      From: <u>${this.history.start_date_formatted || "N/A"}</u> &nbsp;&nbsp;
                      To: <u>${this.history.end_date_formatted || "N/A"}</u></p>`;
      }
    },


    copyLink(link) {
      navigator.clipboard.writeText(link);
      this.$toastr.s("Link copied to clipboard.");
    }
  }
}
</script>

<style scoped>
</style>
